import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { API_ENDPOINTS } from '@common/utils/api-endpoints.const';
import {
  ApiFund,
  ApiMeta,
  FundsApiResponse,
  FundStatus,
} from '../models/fund-api.model';
import {
  ApiFundDetail,
  FundDetailApiResponse,
} from '../../fund-details/models/fund-detail-api.model';

export interface FundsPage {
  funds: ApiFund[];
  meta: ApiMeta;
}

@Injectable({ providedIn: 'root' })
export class FundsService {
  private readonly http = inject(HttpClient);

  getFunds(page = 1, status?: FundStatus): Observable<FundsPage> {
    let params = new HttpParams().set('page', page);
    if (status) params = params.set('filter[status]', status);
    return this.http
      .get<FundsApiResponse>(API_ENDPOINTS.FUNDS, { params })
      .pipe(map(response => ({ funds: response.data, meta: response.meta })));
  }

  getFundDetail(uuid: string): Observable<ApiFundDetail> {
    return this.http
      .get<FundDetailApiResponse>(API_ENDPOINTS.FUND_DETAIL(uuid))
      .pipe(map(response => response.data));
  }
}
